import React, { useState, useEffect } from 'react';

export default function QueryForm({ updateQuery, terms }) {
  const [isActive, setIsActive] = useState('%');
  const [isLoading, setLoading] = useState(false);

  const handleClick = (event) => {
    event.target.className = 'btn btn--select active';
    setIsActive(event.target.name);

    const queryParams = {
      terms: event.target.name
    };

    updateQuery(queryParams);
  };

  useEffect(() => {
    setLoading(true);
    updateQuery();
  }, []);

  return (
    <section className="section">
      <div id="products-finder" className="products-finder">
        <div className="container container--xl">
          <div className="grid">
            <div className="grid__col-xs-12">
              <h2 className="h5 products-finder__label">Browse by Category</h2>
              <div className="categories-container">
                {/* All */}
                <a
                  key={0}
                  name=""
                  id="all"
                  className={`btn btn--select ${
                    isActive == '%' ? 'active' : ''
                  }`}
                  onClick={(event) => handleClick(event)}
                >
                  All
                </a>
                {/* Terms Loop */}
                {terms.map((term) => (
                  <a
                    key={term.id}
                    name={term.id}
                    className={`btn btn--select ${
                      isActive == term.id ? 'active' : ''
                    }`}
                    onClick={(event) => handleClick(event)}
                  >
                    {term.name}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
